// @core/api/endpoints/legalentity/verify_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LegalEntityResponse,
  VerifyLegalEntityRequest,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Verify legal entity requisites
 * Marks the legal entity as verified after cross-checking identifiers against an external registry. The registry is chosen automatically by country_code via the registered adapter. Verification metadata (source, snapshot) stored as evidence.
 */
export async function VerifyLegalEntity(
  legal_entity_id: string,
  data: VerifyLegalEntityRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id/verify`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.post<LegalEntityResponse>(requestPath, data, requestOptions);
}
